import { UrlConnectionCredentials } from "common";
import { createContext, type JSX, ReactNode, useState } from "react";

interface Props {
  children?: ReactNode;
}

export interface IUrlDataConnectionContext {
  starterUrl: string;
  setStarterUrl: (newState: string) => void;
  connectionCredentials: UrlConnectionCredentials | null;
  setConnectionCredentials: (newState: UrlConnectionCredentials) => void;
}

const initial = {
  starterUrl: "",
  setStarterUrl: (): void => {},
  connectionCredentials: null,
  setConnectionCredentials: (): void => {},
};

const UrlDataConnectionContext =
  createContext<IUrlDataConnectionContext>(initial);

const UrlDataConnectionProvider = ({ children }: Props): JSX.Element => {
  const [starterUrl, setStarterUrl] = useState("");
  const [connectionCredentials, setConnectionCredentials] =
    useState<UrlConnectionCredentials | null>(null);

  return (
    <UrlDataConnectionContext.Provider
      value={{
        starterUrl,
        setStarterUrl,
        connectionCredentials,
        setConnectionCredentials,
      }}>
      {children}
    </UrlDataConnectionContext.Provider>
  );
};

export { UrlDataConnectionContext, UrlDataConnectionProvider };
